import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "collapsible", "trigger" ]
  static classes = [ "active" ]

  toggle(event) {
    const trigger = event.currentTarget
    const wasExpanded = trigger.classList.contains(this.activeClass)
    
    trigger.classList.toggle(this.activeClass)
    
    // Update aria-expanded to reflect the new state after toggle
    // (was expanded -> now collapsed, was collapsed -> now expanded)
    trigger.setAttribute("aria-expanded", !wasExpanded)
    
    this.collapsibleTargets.forEach(target => {
      target.classList.toggle(this.activeClass)
    })
  }
  
  connect() {
    // Set initial aria-expanded state
    if (this.hasTriggerTarget) {
      const isExpanded = this.triggerTarget.classList.contains(this.activeClass)
      this.triggerTarget.setAttribute("aria-expanded", isExpanded)
    }
  }
}
